export default "__VITE_ASSET__c53a8448__"